import React, { useCallback, useEffect, useMemo, useState } from 'react';
import './AdminAdministration.scss'
import { apiAdministration } from '../../../axios';
import { MdDelete } from "react-icons/md";
import { FaPen } from "react-icons/fa";
import { adminPersonPost, adminPersonDelete, adminPersonUpdate } from '../../../axios/admin/manageAdministrations';
import { alertForConfirmRequest } from '../../../utils/helpers';
import { useModal } from '../../../components/Modals';
import Table from '../../../components/Table';

const AdminAdministration = () => {

    const dispatchModal = useModal();
    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(true);

    const getData = useCallback(async (paramsObj) => {
        try {
            setLoading(true);
            const result = await apiAdministration.getAdministration(paramsObj);
            setData(result);
            setLoading(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    }, []);

    const createHandler = useCallback(async (fieldsObj = {}) => {
        await adminPersonPost(fieldsObj);
        getData({
            search: search
        });
    }, [getData, search]);

    const deleteHandler = useCallback(async (id) => {
        await adminPersonDelete({
            id: id
        });
        getData({
            search: search
        });
    }, [getData, search]);

    const updateHandler = useCallback(async (fieldsObj) => {
        await adminPersonUpdate(fieldsObj);
        getData({
            search: search
        });
    }, [getData, search]);

    const createOrUpdate = useCallback((obj = {}) => {
        dispatchModal('createEditAdministration', { obj: obj, handleSuccess: (result) => obj?.id ? updateHandler(result) : createHandler(result) })
    }, [dispatchModal, createHandler, updateHandler]);

    useEffect(() => {
        getData({
            search: search
        });
    }, [getData, search]);

    const columns = useMemo(() => [
        {
            key: "fio",
            children: "ПІП"
        },
        {
            key: "position",
            children: "Посада"
        },
        {
            key: "phone",
            style:{ 
                width: 180
            },
            children: "Телефон"
        },
        {
            key: "controls",
            style:{ 
                width: 145
            },
            children: "Керування"
        }
    ], []);

    const dataRows = useMemo(() => data.map(person => ({
        key: person?._id,
        className: 'admin_table_row',
        rowData: [
            {
                children: <>{person?.firstName} {person?.secondName} {person?.surname}</>
            },
            {
                children: person?.position
            },
            {
                children: person?.phone
            },
            {
                className: 'admin_controll_btn',
                children: <>
                    <button
                        className='admin_rewrite_btn'
                        onClick={() => createOrUpdate({
                            id: person?._id,
                            firstName: person?.firstName,
                            secondName: person?.secondName,
                            surname: person?.surname,
                            position: person?.position,
                            phone: person?.phone
                        })}
                    >
                        <FaPen />
                    </button>
                    <button
                        className='admin_delete_btn'
                        onClick={() => alertForConfirmRequest(deleteHandler, person?._id)}
                    >
                        <MdDelete />
                    </button>
                </>
            }
        ]
    })), [data, createOrUpdate, deleteHandler]);

    const emptyText = useMemo(() => {
        return search === '' ? <div className='admin_empty_table'>
            Список адмінітрації порожній
            <br />
            <button className='admin_create_element' onClick={() => createOrUpdate()}>Створити</button>
        </div> : `За пошуком "${search}" нікого не знайдено`
    }, [search, createOrUpdate]);

    return (
        <section className='admin_administration_wrapper'>
            <div className='admin_page_content'>
                <h2 className='admin_page_title'>
                    Адміністрація
                </h2>
                <div className='admin_filters_block'>
                    <input className='admin_search_input' type='text' placeholder='Пошук' onChange={e => setSearch(e.target.value)} />
                    <button className='admin_create_element' onClick={() => createOrUpdate()}>Створити</button>
                </div>

                <div className='admin_table_block'>
                    <Table
                        columns={columns}
                        data={dataRows}
                        loading={loading}
                        emptyText={emptyText}
                    />
                </div>
            </div>
        </section>
    );
};

export default AdminAdministration;